import {https,httpsFile} from './http.js';

export async function index(data){
    return https().get(`/inventories?${data}`);
}

export async function show(value,company){
    return https().get(`/inventories${value}?company=${company}`);
}

export async function create(data){
    return https().get(`/inventories/create?${data}`)
}

export async function exportInventory(data){
    return https().get(`/export-inventory?${data}`);
}

export async function downloadExport(data){
    // return https().get(`/export-inventory/download?file_path=${data}`, { responseType: "blob" });
    return https().get(`downloads?file_path=${data}`, { responseType: "blob" });
}

export async function searchMaterial(search,issuing_plant,receiving_plant,issuing_store_loc,page, currentpage,sortby,sortdir,receiving_store_loc,search_for,filter=null){
    return https().get(`/searchMaterial?search=${search}
        &issuing_plant=${issuing_plant}&receiving_plant=${receiving_plant}&issuing_store_loc=${issuing_store_loc}
        &page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&receiving_store_loc=${receiving_store_loc}
        &search_for=${search_for}&filter=${filter}
        `);
}

export async function searchMaterialTrucking(search,issuing_plant,receiving_plant,issuing_store_loc,page, currentpage,sortby,sortdir,receiving_store_loc,search_for,filter=null){
    return https().get(`/searchMaterialTrucking?search=${search}
        &issuing_plant=${issuing_plant}&receiving_plant=${receiving_plant}&issuing_store_loc=${issuing_store_loc}
        &page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&receiving_store_loc=${receiving_store_loc}
        &search_for=${search_for}&filter=${filter}
        `);
}

export async function showInventoryMaterials(data){
    return https().get(`/show-inventory-materials?${data}`);
}

export async function showInventoryMaterialsPVC(data){
    return https().get(`/show-inventory-materials-pvc?${data}`);
}

export async function exportPackage(data){
    return https().get(`/stpo-exports?${data}`);
}